module.exports = __webpack_public_path__ + "static/svoboda-small-2c906d57c3f490f0ca8e9db18676260e.webp";